import {
  ClickAwayListener as MaterialClickAwayListener,
  ClickAwayListenerProps
} from '@mui/material'

const ClickAwayListener = ({
  children,
  onClickAway
}: ClickAwayListenerProps) => {
  return (
    <MaterialClickAwayListener onClickAway={onClickAway}>
      <div>{children}</div>
    </MaterialClickAwayListener>
  )
}

export default ClickAwayListener
